import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-14" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-15" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-16" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-17" data-mp="fsv9ulhm6hlp">🎁 </span>5 Regali Strategici Esclusivi
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-18" data-mp="1u598vvl5zsl">
          Valore totale{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-19" data-mp="5w8pryx43ukq">116€</span> —
          inclusi oggi <span className="font-bold text-brand" data-id="element-20" data-mp="3o24wk676k5wf">GRATIS</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-21" data-mp="3o3y2fj9yym3d">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(23,15,20,0.06)] sm:gap-5 sm:p-5" data-id="element-22" data-mp="3t2sn6qrhykq4" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-23" data-mp="1r8ju353hh2it">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" loading="lazy" className="h-44 w-32 shrink-0 object-contain sm:h-56 sm:w-44" data-id="element-24" data-mp="3df3cvwxibvnp" />
              <div className="min-w-0" data-id="element-25" data-mp="3n5y6xngzvzjp">
                <h3 className="font-display text-base font-bold leading-snug text-ink" data-id="element-26" data-mp="2zf2a2bxome5l">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-ink/55" data-id="element-27" data-mp="2ui22txp3j5cw">
                  {bonus.text}
                </p>
                <p className="mt-2 text-[11px] font-bold" data-id="element-28" data-mp="38e5ubj8l4zlo">
                  <span className="text-amber-700 line-through" data-id="element-29" data-mp="33g4er8adbiey">
                    Valore {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-30" data-mp="ns4bqd4poebe">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}